module.exports = __webpack_public_path__ + "static/media/app-dev.781585bb.png";